import { Box, Button } from '@mui/material';
import { useSimpleSearchTheme } from '@/shared/ui/search/SimpleSearch/theme/useSimpleSearchTheme';
import { SearchInput } from '@/shared/ui/search/SimpleSearch/components/SearchInput';
import { FieldSelectSimple } from '@/shared/ui/search/SimpleSearch/components/FieldSelectSimple';
import { useSimpleSearch } from '@/shared/ui/search/SimpleSearch/hooks/useSimpleSearch';
import type {
  SimpleSearchConfig,
  SimpleSearchQuery,
} from '@/shared/ui/search/SimpleSearch/types/search.types';

interface SimpleSearchProps {
  config: SimpleSearchConfig;
  onSearch: (query: SimpleSearchQuery) => void;
  initialQuery?: SimpleSearchQuery;
  endAdornment?: React.ReactNode;
}

export function SimpleSearch({ config, onSearch, initialQuery, endAdornment }: SimpleSearchProps) {
  const theme = useSimpleSearchTheme();
  const { query, setFieldName, setValue } = useSimpleSearch(initialQuery);

  const handleSearch = () => {
    onSearch(query);
  };

  const handleEnter = () => {
    handleSearch();
  };

  return (
    <Box sx={theme.containerSx}>
      {config.enableFieldSelect && config.fields && config.fields.length > 0 && (
        <FieldSelectSimple
          value={query.fieldName || config.fields[0].name}
          fields={config.fields}
          onChange={setFieldName}
        />
      )}

      <SearchInput
        value={query.value}
        onChange={setValue}
        onEnter={handleEnter}
        placeholder={config.placeholder}
      />

      <Button variant="contained" onClick={handleSearch} sx={theme.searchButtonSx}>
        검색
      </Button>
      {endAdornment}
    </Box>
  );
}
